import { produce } from "immer";
import { tKey, tSetTableConfig, tTableConfigAction, tTableConfigState, tTables } from "./types";

export const kDefaultTableConfigState: Record<tTables, Record<tKey, boolean>> = {
  orders: {},
  connections: {},
  customers: {},
  applications: {},
  salesReps: {},
  savedBrands: {},
  promotions: {},
  products: {},
  inventoryManagament: {},
  totalSales: {},
  totalSalesBySKU: {},
  brandsExcelFormat: {},
  retailersExcelFormat: {},
  connectionRequestsExcelFormat: {},
  brandInvitingRetailerExcelFormat: {},
  newProductsExcelFormat: {},
  productsInventoryReport: {},
  abandonedCartsReport: {},
  adminTransactionsData: {},
};

const handleSetTableConfig = (state: tTableConfigState, action: tSetTableConfig): tTableConfigState => {
  return { ...state, [action.key]: action.config };
};

export const TableConfigReducer = produce(
  (state: tTableConfigState = kDefaultTableConfigState, action: tTableConfigAction): tTableConfigState => {
    switch (action.type) {
      case "SET_TABLE_CONFIG":
        return handleSetTableConfig(state, action);
      default:
        return state;
    }
  },
);
